import React, { useEffect, useRef, useState } from "react";
import { InputNumber, Button, Input, Row, Col, Typography, Divider, Tooltip } from "antd";
import { CaretDownOutlined } from '@ant-design/icons';
import Highcharts, { color } from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import wbg from '../Assets/wbg.png'
import btc from "../Assets/btc.png"
import DropDown from "./DropDown";
import Annotations from "highcharts/modules/annotations";

//  Annotations(Highcharts); // 👈 init the module

const { Text } = Typography;
const initialData = (() => {
    const data = [];
    let time = new Date('2025-10-01T09:00:00Z').getTime();
    let price = 150;
    for (let i = 0; i < 20; i++) {
        const open = price + (Math.random() - 0.5);
        const high = open + Math.random() * 2;
        const low = open - Math.random() * 2;
        const close = low + Math.random() * (high - low);
        data.push([time, open, high, low, close]);
        price = close;
        time += 24 * 3600 * 1000; // Add one day
    }
    return data;
})();

const LiveHighChart = () => {
    const chartRef = useRef(null);
    const [quantity, setQuantity] = useState(null);
    // const [price2, setPrice2] = useState(null);
    const [plotLines, setPlotLines] = useState([]);
    const inputRef = useRef(null);
    const inputRef2 = useRef(null);
    const inputRef3 = useRef(null);
    const [focused, setFocused] = useState(0);
    const lastCandle = initialData[initialData.length - 1];
    const xValue = lastCandle[0];      // This is the timestamp (x axis coordinate).
    const yValue = lastCandle[2];      // For example, use 'high' value for the arrow target.
    const arrowHeight = 2;             // Height above the target (in price units).

    const handleAddPlotLine = () => {
        const newPrice = Number(quantity); // can be input or fixed

        const newLine = {
            value: newPrice,
            color: 'yellow',
            dashStyle: 'Dash',
            width: 2,
            label: {
                text: `Bet Price ${newPrice}`,
                align: 'right',
                x: -10,
                style: { color: '#fff', fontWeight: 'bold' }
            },
            zIndex: 10
        };

        // ✅ Add new line without overwriting old ones
        setPlotLines(prev => [...prev, newLine]);

        // ✅ Update chartOptions to trigger re-render
        setChartOptions(prev => ({
            ...prev,
            yAxis: {
                ...prev.yAxis,
                plotLines: [...plotLines, newLine]
            }
        }));
        setQuantity("")
    };



    // const setPrice2 = 150.45; // ✅ Your target/buy/alert price
    const [chartOptions, setChartOptions] = useState({
        chart: {
            type: 'candlestick',
            backgroundColor: 'transparent',
        },
        title: {
            text: 'Live Stock Price with Set Price Line',
            style: { color: '#fff' }
        },
        xAxis: {
            type: 'datetime',
            labels: { style: { color: '#ffffff65' } },
            gridLineColor: 'rgba(255,255,255,0.1)'
        },
        tooltip: {
            enabled: false // 👈 disables the tooltip completely
        },
        yAxis: {
            title: { text: 'Price (USD)', style: { color: '#ffffff65' } },
            labels: { style: { color: '#ffffff59' } },
            gridLineColor: 'rgba(255,255,255,0.1)',
            plotLines: plotLines, // 🧠 This connects to the state

        },
        series: [
            {
                name: 'Stock Price',
                data: initialData,
                color: '#C24332',
                upColor: '#037c26'
            }
        ]
    });

    // ==========================================================
    // == 💡 PULSATING MARKER EFFECT 💡
    // ==========================================================
    useEffect(() => {
        const handleAddPoint = (e) => {
            const point = e.point;
            const series = e.target;

            if (series.type !== 'candlestick') {
                return;
            }

            if (!series.pulse) {
                series.pulse = series.chart.renderer.circle().add(series.markerGroup);
            }

            setTimeout(() => {
                // Ensure the point has a close value before proceeding
                if (typeof point.close !== 'undefined') {
                    series.pulse
                        .attr({
                            x: series.xAxis.toPixels(point.x, true),
                            // Use point.close for the candle's Y position
                            y: series.yAxis.toPixels(point.close, true),
                            r: series.options.marker?.radius || 5,
                            opacity: 1,
                            fill: '#4dce07ff' // A distinct color for the pulse
                        })
                        .animate(
                            { r: 20, opacity: 0 },
                            { duration: 1000, easing: 'linear' }
                        );
                }
            }, 1);
        };

        // Add the custom event listener
        Highcharts.addEvent(Highcharts.Series, "addPoint", handleAddPoint);

        // Cleanup function to remove the event listener when the component unmounts
        return () => Highcharts.removeEvent(Highcharts.Series, "addPoint", handleAddPoint);
    }, []); // Empty dependency array ensures this runs only once
    // ==========================================================


    // == ⏱️ SIMULATE REAL-TIME DATA ⏱️
    // This effect adds a new point every 3 seconds to trigger the pulse
    // ==========================================================
    useEffect(() => {
        let userScrolledBack = false; // track if user moved manually
        if (!chartRef.current) return;
        const chart = chartRef.current.chart;

        // Detect manual scroll or zoom
        Highcharts.addEvent(chart.xAxis[0], 'setExtremes', (e) => {
            if (e.trigger === 'pan' || e.trigger === 'zoom') userScrolledBack = true;
        });

        const interval = setInterval(() => {
            if (!chartRef.current || !chartRef.current.chart) return;

            const series = chart.series[0];
            const lastPoint = series.data[series.data.length - 1];

            const newTime = lastPoint.x + 24 * 3600 * 1000; // next candle
            const lastClose = lastPoint.close;

            const newOpen = lastClose + (Math.random() - 0.5) * 0.5;
            const newHigh = newOpen + Math.random() * 2;
            const newLow = newOpen - Math.random() * 2;
            const newClose = newLow + Math.random() * (newHigh - newLow);

            // ✅ Add new candle as object
            series.addPoint(
                { x: newTime, open: newOpen, high: newHigh, low: newLow, close: newClose },
                true, // redraw
                false // do not shift
            );

            // Auto-scroll if user hasn’t scrolled away
            if (!userScrolledBack) {
                const totalPoints = series.data.length;
                if (totalPoints > 20) {
                    const firstVisible = series.data[totalPoints - 20].x;
                    chart.xAxis[0].setExtremes(firstVisible, newTime, true, { duration: 400 });
                }
            }
        }, 1500);

        return () => clearInterval(interval);
    }, []);


    //live price plot candle
    useEffect(() => {
        const interval = setInterval(() => {
            if (!chartRef.current?.chart) return;

            const chart = chartRef.current.chart;
            const series = chart.series[0];
            const lastPoint = series.data[series.data.length - 1];
            const currentPrice = lastPoint.close;

            // Remove any existing line (optional, to avoid duplicates)
            chart.yAxis[0].removePlotLine('current-price-line');

            // Add a new one at the latest close price
            chart.yAxis[0].addPlotLine({
                id: 'current-price-line',
                value: currentPrice,
                color: '#cccccc6e',
                width: 2,
                dashStyle: 'Dash',
                zIndex: 10,
                // label: {
                //     text: `Live Price: ${currentPrice.toFixed(2)}`,
                //     align: 'right',
                //     x: -10,
                //     y: 20,
                //     style: {
                //         color: '#fff',
                //         fontWeight: 'bold',
                //         background: 'rgba(0, 0, 0, 0)',
                //     },
                // },
            });

            // Add custom styled label using renderer
            const label = chart.renderer
                .label(
                    `Live Price: ${currentPrice.toFixed(2)}`,
                    chart.chartWidth - 10, // x position (right side)
                    chart.yAxis[0].toPixels(currentPrice) - (-5), // y position based on price
                    'callout', // shape
                    null,
                    null,
                    true
                )
                .attr({
                    zIndex: 20,
                    align: 'right',
                    padding: 6,
                    r: 12, // border radius
                    // fill: 'rgba(255, 255, 255, 1)', // background
                })
                .css({
                    color: '#18df7bff',
                    fontSize: '13px',
                    fontWeight: 'bold',
                })
                .add();

            // Optional: animate opacity and auto-destroy after 2 seconds
            label.animate(
                { opacity: 0 },
                {
                    duration: 2000,
                    complete: function () {
                        this.destroy();
                    },
                }
            );
        }, 1000); // update every 1s or match your live update interval

        return () => clearInterval(interval);
    }, []);

    // ==========================================================
    // == 🎯 DYNAMIC Y-AXIS PLOTLINE ON HOVER 🎯
    // ==========================================================
    useEffect(() => {
        if (!chartRef.current) return;
        const chart = chartRef.current.chart;
        const yAxis = chart.yAxis[0];

        let hoverLineId = 'hover-line';
        let alertIndex = 0;
        let lastHoveredPrice = null;
        const alertLines = {}; // store active alerts with direction

        // ===== 🟡 TRACK HOVER LINE =====
        const handleMouseMove = (e) => {
            const event = chart.pointer.normalize(e);
            const hoveredY = chart.yAxis[0].toValue(event.chartY);
            lastHoveredPrice = hoveredY;

            yAxis.removePlotLine(hoverLineId);
            yAxis.addPlotLine({
                id: hoverLineId,
                color: '#cccc',
                width: 1,
                value: hoveredY,
                dashStyle: 'Dash',
                zIndex: 5,
                label: {
                    text: `🔔 ${hoveredY.toFixed(2)}`,
                    align: 'right',
                    x: -10,
                    style: { color: '#fff', fontWeight: 'bold' },
                },
            });
        };

        const handleMouseOut = () => {
            yAxis.removePlotLine(hoverLineId);
        };

        // ===== 🔔 ADD ALERT LINE (on double-click) =====
        const handleDoubleClick = () => {
            if (lastHoveredPrice == null) return;
            alertIndex += 1;
            const alertId = `alert-line-${alertIndex}`;

            const currentPrice = chart.series[0].data.slice(-1)[0].close;
            const direction = lastHoveredPrice > currentPrice ? 'up' : 'down'; // detect direction

            alertLines[alertId] = { price: lastHoveredPrice, direction };

            const color = direction === 'up' ? '#00ff7f' : '#ff4444';
            const icon = direction === 'up' ? '🔼' : '🔽';

            yAxis.addPlotLine({
                id: alertId,
                color,
                width: 1.5,
                value: lastHoveredPrice,
                dashStyle: 'Dash',
                zIndex: 6,
                label: {
                    text: `${icon} ${lastHoveredPrice.toFixed(2)}`,
                    align: 'right',
                    x: -10,
                    style: { color: '#fff', fontWeight: 'bold' },
                },
            });

            chart.renderer
                .label(`${icon} Alert set at ${lastHoveredPrice.toFixed(2)}`, (chart.chartWidth - 150), 0, 'callout', null, null, true)
                .attr({ zIndex: 999 })
                .css({
                    color,
                    fontSize: '13px',
                    background: 'rgba(0,0,0,0.7)',
                    padding: '4px 8px',
                    borderRadius: '6px',
                })
                .add()
                .animate({ opacity: 0 }, { duration: 2000, complete: function () { this.destroy(); } });
        };

        // ===== 🔊 PLAY SOUND =====
        const playAlertSound = () => {
            const audio = new Audio('https://actions.google.com/sounds/v1/alarms/beep_short.ogg');
            audio.play().catch(() => { });
        };

        // ===== 📈 WATCH PRICE EACH REDRAW =====
        const checkAlerts = () => {
            const series = chart.series[0];
            if (!series || !series.data.length) return;

            const lastPoint = series.data[series.data.length - 1];
            const currentPrice = lastPoint.close;

            Object.entries(alertLines).forEach(([id, { price: alertPrice, direction }]) => {
                // ✅ Trigger alert based on direction
                const hit =
                    (direction === 'up' && currentPrice >= alertPrice) ||
                    (direction === 'down' && currentPrice <= alertPrice);

                if (hit) {
                    playAlertSound();

                    // Remove alert line and clean up
                    yAxis.removePlotLine(id);
                    delete alertLines[id];

                    const icon = direction === 'up' ? '🚀' : '📉';
                    chart.renderer
                        .label(`${icon} Price hit ${alertPrice.toFixed(2)}!`, (chart.chartWidth - 150), 30, 'callout', null, null, true)
                        .attr({ zIndex: 999 })
                        .css({
                            color: '#ffcc00',
                            fontSize: '13px',
                            background: 'rgba(0,0,0,0.7)',
                            padding: '4px 8px',
                            borderRadius: '6px',
                        })
                        .add()
                        .animate({ opacity: 0 }, { duration: 2500, complete: function () { this.destroy(); } });
                }
            });
        };

        // Run check after every chart redraw (new candle, pan, etc.)
        Highcharts.addEvent(chart, 'redraw', checkAlerts);

        // ===== ⚙️ EVENT ATTACHMENT =====
        const container = chart.container;
        container.addEventListener('mousemove', handleMouseMove);
        container.addEventListener('mouseleave', handleMouseOut);
        container.addEventListener('dblclick', handleDoubleClick);

        // ===== 🧹 CLEANUP =====
        return () => {
            container.removeEventListener('mousemove', handleMouseMove);
            container.removeEventListener('mouseleave', handleMouseOut);
            container.removeEventListener('dblclick', handleDoubleClick);
            yAxis.removePlotLine(hoverLineId);
            Highcharts.removeEvent(chart, 'redraw', checkAlerts);
        };
    }, []);




    return (
        < >
            <div className="lef-panel">
                <div className="display-1 gap-15 align-start">
                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="2" fill="#3C4150" />
                        <path d="M15.7168 7.01367C16.0675 6.66293 16.6354 6.66232 16.9863 7.0127C17.3374 7.36361 17.3383 7.93227 16.9873 8.2832L13.2695 12L16.9863 15.7168C17.3374 16.0677 17.3383 16.6364 16.9873 16.9873C16.8124 17.1622 16.582 17.2499 16.3525 17.25C16.1229 17.25 15.8918 17.1623 15.7168 16.9873L12 13.2695L8.2832 16.9873C8.10827 17.1622 7.8779 17.2499 7.64844 17.25C7.41912 17.25 7.1886 17.1621 7.01367 16.9873C6.68453 16.6583 6.66318 16.138 6.95117 15.7852L7.01367 15.7168L10.7305 12L7.01367 8.2832C6.68453 7.95421 6.66318 7.43389 6.95117 7.08105L7.01367 7.0127C7.36462 6.66222 7.93234 6.66208 8.2832 7.0127V7.01367L12 10.7305L15.7168 7.01367Z" fill="#82858E" stroke="#82858E" stroke-width="0.5" />
                    </svg>
                    <div>

                        <DropDown>
                            <div className="display-1 align-start cursor">
                                <img src={btc} width={35} />
                                <div className="trade-act">
                                    NZD/USD (OTC)
                                    <div className="trade-act-typ">
                                        Blitz
                                    </div>
                                </div>
                                <CaretDownOutlined style={{ color: "#fff" }} />
                            </div>
                        </DropDown>

                        <div className="display-1 mt-10 ">
                            <svg width="70" height="35" viewBox="0 0 70 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2.66666" y="1.66666" width="65.3333" height="32" rx="16" fill="#494D5C" />
                                <path d="M21.3329 8.33333C16.179 8.33333 12 12.5123 12 17.6663C12 22.8202 16.179 27 21.3329 27C26.4869 27 30.6667 22.8202 30.6667 17.6663C30.6667 12.5123 26.4869 8.33333 21.3329 8.33333ZM23.2759 22.7981C22.7955 22.9877 22.413 23.1316 22.1262 23.2311C21.8402 23.3307 21.5076 23.3804 21.1291 23.3804C20.5476 23.3804 20.0948 23.2382 19.7724 22.9546C19.4501 22.6709 19.2897 22.3114 19.2897 21.8745C19.2897 21.7046 19.3015 21.5308 19.3252 21.3538C19.3497 21.1768 19.3884 20.9777 19.4414 20.7541L20.0427 18.6302C20.0956 18.4264 20.1414 18.2328 20.1778 18.0526C20.2141 17.8709 20.2315 17.7042 20.2315 17.5525C20.2315 17.2823 20.1754 17.0926 20.064 16.986C19.951 16.8793 19.7385 16.8272 19.4216 16.8272C19.2668 16.8272 19.1072 16.8501 18.9436 16.8983C18.7816 16.948 18.641 16.9931 18.5256 17.0373L18.6844 16.3831C19.0779 16.2227 19.4548 16.0852 19.8143 15.9715C20.1738 15.8561 20.5136 15.7992 20.8336 15.7992C21.4112 15.7992 21.8568 15.9398 22.1705 16.218C22.4826 16.4969 22.6398 16.8596 22.6398 17.3052C22.6398 17.3976 22.6287 17.5604 22.6074 17.7927C22.5861 18.0258 22.5458 18.2383 22.4873 18.4335L21.8892 20.551C21.8402 20.7209 21.7967 20.9153 21.7572 21.1325C21.7185 21.3498 21.6996 21.5157 21.6996 21.6272C21.6996 21.9084 21.762 22.1004 21.8884 22.2024C22.0132 22.3043 22.2321 22.3556 22.5418 22.3556C22.688 22.3556 22.8516 22.3296 23.0364 22.279C23.2198 22.2284 23.3525 22.1834 23.4362 22.1447L23.2759 22.7981ZM23.17 14.2032C22.8911 14.4623 22.5553 14.5919 22.1626 14.5919C21.7707 14.5919 21.4325 14.4623 21.1512 14.2032C20.8715 13.944 20.7301 13.6287 20.7301 13.2605C20.7301 12.8931 20.8723 12.5771 21.1512 12.3156C21.4325 12.0532 21.7707 11.9229 22.1626 11.9229C22.5553 11.9229 22.8919 12.0532 23.17 12.3156C23.4489 12.5771 23.5887 12.8931 23.5887 13.2605C23.5887 13.6295 23.4489 13.944 23.17 14.2032Z" fill="#A9AAB2" />
                                <path d="M37.4091 13.9394V22.6667H36.6122V13.9394H37.4091ZM40.3303 18.5758V22.6667H39.5717V16.1212H40.3089V17.1482H40.3771C40.5305 16.813 40.7692 16.5445 41.093 16.3428C41.4197 16.1383 41.8231 16.036 42.3033 16.036C42.7436 16.036 43.13 16.1283 43.4624 16.313C43.7976 16.4948 44.0575 16.7633 44.2422 17.1184C44.4297 17.4735 44.5234 17.9096 44.5234 18.4266V22.6667H43.7649V18.4735C43.7649 17.9366 43.6143 17.5118 43.3132 17.1993C43.0149 16.8868 42.6143 16.7306 42.1115 16.7306C41.7678 16.7306 41.4624 16.8045 41.1953 16.9522C40.9283 17.0999 40.7166 17.313 40.5604 17.5914C40.407 17.867 40.3303 18.1951 40.3303 18.5758ZM49.2141 16.1212V16.7817H45.9968V16.1212H49.2141ZM47.0025 22.6667V15.1624C47.0025 14.8101 47.0834 14.5133 47.2454 14.2718C47.4102 14.0303 47.6246 13.8471 47.8888 13.7221C48.153 13.5971 48.4329 13.5346 48.7283 13.5346C48.9272 13.5346 49.092 13.5516 49.2227 13.5857C49.3562 13.617 49.4613 13.6482 49.538 13.6795L49.3164 14.3442C49.2596 14.3272 49.19 14.3073 49.1076 14.2846C49.0252 14.2618 48.9215 14.2505 48.7965 14.2505C48.467 14.2505 48.2127 14.3428 48.0337 14.5275C47.8548 14.7121 47.7653 14.9763 47.7653 15.3201L47.761 22.6667H47.0025ZM53.0025 22.803C52.4371 22.803 51.9371 22.6596 51.5025 22.3726C51.0707 22.0857 50.7326 21.6894 50.4883 21.1837C50.244 20.6752 50.1218 20.0885 50.1218 19.4238C50.1218 18.7533 50.244 18.1638 50.4883 17.6553C50.7326 17.1439 51.0707 16.7462 51.5025 16.4621C51.9371 16.1752 52.4371 16.0317 53.0025 16.0317C53.5678 16.0317 54.0664 16.1752 54.4982 16.4621C54.93 16.7491 55.2681 17.1468 55.5124 17.6553C55.7596 18.1638 55.8832 18.7533 55.8832 19.4238C55.8832 20.0885 55.761 20.6752 55.5167 21.1837C55.2724 21.6894 54.9329 22.0857 54.4982 22.3726C54.0664 22.6596 53.5678 22.803 53.0025 22.803ZM53.0025 22.1084C53.457 22.1084 53.842 21.9863 54.1573 21.742C54.4727 21.4976 54.7113 21.1724 54.8732 20.7661C55.038 20.3599 55.1204 19.9124 55.1204 19.4238C55.1204 18.9351 55.038 18.4863 54.8732 18.0772C54.7113 17.6681 54.4727 17.34 54.1573 17.0928C53.842 16.8456 53.457 16.7221 53.0025 16.7221C52.5508 16.7221 52.1658 16.8456 51.8477 17.0928C51.5323 17.34 51.2923 17.6681 51.1275 18.0772C50.9656 18.4863 50.8846 18.9351 50.8846 19.4238C50.8846 19.9124 50.9656 20.3599 51.1275 20.7661C51.2923 21.1724 51.5323 21.4976 51.8477 21.742C52.163 21.9863 52.5479 22.1084 53.0025 22.1084Z" fill="#BBBDC2" />
                            </svg>
                            <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="34.6667" rx="17.3333" fill="#454A58" />
                                <path d="M26.0871 22.4521C24.6759 21.2593 23.8667 19.5159 23.8667 17.6688V15.0667C23.8667 11.7823 21.4269 9.06347 18.2667 8.60801V7.60001C18.2667 7.08387 17.8485 6.66667 17.3333 6.66667C16.8181 6.66667 16.4 7.08387 16.4 7.60001V8.60801C13.2388 9.06347 10.8 11.7823 10.8 15.0667V17.6688C10.8 19.5159 9.9908 21.2593 8.5712 22.4596C8.20813 22.7704 8 23.2221 8 23.7C8 24.6007 8.73267 25.3333 9.63333 25.3333H25.0333C25.934 25.3333 26.6667 24.6007 26.6667 23.7C26.6667 23.2221 26.4585 22.7704 26.0871 22.4521Z" fill="#9499A0" />
                                <path d="M17.3313 28.1319C19.0216 28.1319 20.4356 26.9269 20.7604 25.3319H13.9022C14.227 26.9269 15.641 28.1319 17.3313 28.1319Z" fill="#9499A0" />
                            </svg>
                            <svg width="35" height="35" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13.6667" cy="13.6667" r="13.3333" fill="#464A59" />
                                <path d="M20.8437 12.5476L17.7775 15.5365L18.5016 19.7579C18.5331 19.9425 18.4573 20.1291 18.3057 20.2393C18.2201 20.3018 18.1182 20.3333 18.0163 20.3333C17.938 20.3333 17.8593 20.3146 17.7874 20.2767L13.9962 18.2837L10.2055 20.2762C10.0401 20.3639 9.83875 20.3496 9.68714 20.2388C9.53553 20.1286 9.45973 19.942 9.49123 19.7574L10.2153 15.536L7.14868 12.5476C7.01479 12.4167 6.96606 12.2208 7.02414 12.0431C7.08223 11.8654 7.2363 11.7349 7.42187 11.7079L11.6595 11.0926L13.5546 7.25215C13.7205 6.91595 14.2718 6.91595 14.4377 7.25215L16.3328 11.0926L20.5705 11.7079C20.7561 11.7349 20.9101 11.8649 20.9682 12.0431C21.0263 12.2213 20.9776 12.4162 20.8437 12.5476Z" fill="#9499A0" />
                            </svg>

                        </div>
                    </div>

                </div>


                {/* <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="25" height="25" rx="2" fill="#3C4150" />
                    <path d="M9.5 14.5L6.5 17.5L7.5 19L10.5 16.3453L12.5 17.5V13H8L9.5 14.5Z" fill="#82858E" />
                    <path d="M14.6042 9.15654L17.4972 6.05327L19.0314 7.00011L16.4834 10.0913L17.7075 12.0496L13.2102 12.2073L13.0526 7.71002L14.6042 9.15654Z" fill="#82858E" />
                </svg> */}
                <div>

                    <div className="chart-tools">
                        {/* <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 10V0H5V2H8V4H5V15H3V12.5H0V10H3Z" fill="white" />
                        <path d="M13 9V4H15V15H17.25H19.5V17H16V18H13V11.5H9.5V9H13Z" fill="#D9D9D9" />
                    </svg> */}
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 14.5L4.59808 19L7.5 10.5L12.5 11.5L15 2L19 7.5" stroke="#F6F6F7" />
                            <rect y="7" width="9" height="1" fill="#757983" />
                        </svg>

                    </div>
                    <div className="chart-tools">
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8025 1.77461L12.5665 1.01058C13.4695 0.107638 15.0409 0.107638 15.9439 1.01058L16.5603 1.62702C17.0118 2.07849 17.2636 2.67756 17.2636 3.31136C17.2636 3.94516 17.0118 4.55291 16.5603 4.9957L15.7963 5.75973L11.8025 1.76593V1.77461ZM10.8822 2.69492L2.97271 10.6044C2.72093 10.8562 2.56465 11.1861 2.5386 11.5421L2.30418 14.0859C2.27813 14.4072 2.391 14.7197 2.61674 14.9542C2.82511 15.1625 3.09426 15.2754 3.38077 15.2754H3.47627L6.02015 15.041C6.37612 15.0062 6.70604 14.85 6.95782 14.5982L14.8673 6.68872L10.8735 2.69492H10.8822ZM19 18.045C19 17.689 18.7048 17.3938 18.3488 17.3938H0.984491C0.628522 17.3938 0.333328 17.689 0.333328 18.045C0.333328 18.401 0.628522 18.6962 0.984491 18.6962H18.3488C18.7048 18.6962 19 18.401 19 18.045Z" fill="white" />
                        </svg>

                    </div>
                    <div className="chart-tools">
                        <svg width="19" height="22" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.98604 11.465C4.45074 11.5846 3.11483 11.0463 1.9783 9.84992C0.861719 8.65358 0.353275 7.27779 0.45297 5.72255C0.552665 4.28694 1.1309 3.08063 2.18766 2.10362C3.24443 1.14655 4.50059 0.668015 5.95613 0.668015V3.03079H5.38787C4.80964 3.03079 4.21147 3.34981 3.59336 3.98786C2.97525 4.62591 2.67617 5.30383 2.69611 6.02164C2.71605 6.97871 3.00516 7.73639 3.56345 8.29468C4.08187 8.79316 4.75979 9.05236 5.59723 9.0723C7.05278 9.09224 8.04973 8.26477 8.58808 6.5899L9.21616 4.58603C9.87415 2.49243 11.2998 1.39579 13.4931 1.29609C14.809 1.23628 15.9356 1.67493 16.8727 2.61207C17.8099 3.56914 18.3083 4.71563 18.3682 6.05154C18.428 7.20801 18.0491 8.28471 17.2316 9.28166C16.4341 10.2986 15.4371 10.8469 14.2408 10.9266L13.7323 10.9565V8.56386H14.1212C14.7193 8.56386 15.1979 8.30465 15.5568 7.78624C15.9356 7.28776 16.125 6.70953 16.125 6.05154C16.1051 5.4135 15.8758 4.8552 15.4371 4.37667C14.9985 3.91807 14.4501 3.6788 13.7922 3.65886C12.5759 3.57911 11.7085 4.30688 11.1901 5.84218L10.5321 7.81615C9.75451 10.0892 8.23915 11.3055 5.98604 11.465Z" fill="white" />
                        </svg>


                    </div>
                    <div className="chart-tools">
                        1d

                    </div>
                </div>


            </div>
            <HighchartsReact
                highcharts={Highcharts}
                // constructorType={'stockChart'}
                options={chartOptions}
                ref={chartRef}
                containerProps={{
                    style: {
                        backgroundImage: `url(${wbg})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        height: "100%",
                        width: "85%",
                        overflow: "hidden",
                        margin: "auto 25px auto 20px",
                    },
                }}
            />
            <div style={{ width: 120, height: "100%", background: "transparent", padding: 0, borderRadius: 8, position: 'absolute', right: "0", top: '0%', }}>
                {/* Quantity */}
                <div className="display-2 gap-2">
                    <div
                        className={`quant-c cursor ${focused === 0 ? "focused" : ""}`}
                        onClick={() => {
                            inputRef.current?.focus(); // only focus, no cursor positioning
                            setFocused(0)

                        }}
                    >
                        <div className="quanc-h">Quantity</div>

                        <Input
                            size="small"
                            variant="borderless"
                            type="number"
                            onChange={(e) => { setQuantity(e.target.value) }}
                            placeholder="0"
                            ref={inputRef}
                            value={quantity}
                            onFocus={() => setFocused(true)}
                            onBlur={() => setFocused(false)}
                        />
                    </div>
                    <div className="display-1 flex-c">
                        <svg width="18" height="22" viewBox="0 0 22 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="-3.05176e-05" width="21.3333" height="30.4762" fill="#3A3F4E" />
                            <path d="M10.2493 17.6047V11.8131H11.5633V17.6047H10.2493ZM8.01046 15.3659V14.0519H13.8021V15.3659H8.01046Z" fill="#687086" />
                        </svg>
                        <svg
                            width="16"
                            height="22"
                            viewBox="0 0 22 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <rect y="0.523773" width="21.3333" height="30.4762" fill="#3A3F4E" />
                            <rect x="6.60352" y="12.037" width="8.12698" height="1.3545" fill="url(#pattern0_60_13844)" />
                            <defs>
                                <pattern id="pattern0_60_13844" patternContentUnits="objectBoundingBox" width="1" height="1">
                                    <use xlinkHref="#image0_60_13844" transform="scale(0.166667 1)" />
                                </pattern>
                                <image
                                    id="image0_60_13844"
                                    width="6"
                                    height="1"
                                    preserveAspectRatio="none"
                                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAABCAYAAAD9yd/wAAAAEElEQVR4nGNcvmrDfwYsAABDKwMCrwYv7gAAAABJRU5ErkJggg=="
                                />
                            </defs>
                        </svg>
                    </div>


                </div>
                {/* <div className="floating-input">
                    <Input placeholder=" " />
                    <label>Name</label>
                </div> */}


                <div className="pt-val display-1">
                    Point Value
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z" fill="#8F929B" />
                    </svg>

                </div>
                <div className="pt-amt ">
                    $0.01
                </div>
                <div className="pt-val display-1">
                    Margin
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z" fill="#8F929B" />
                    </svg>

                </div>
                <div className="pt-amt ">
                    $0
                </div>
                <div className="pt-val display-5">
                    Leverage
                    <div style={{ fontWeight: '800' }}>
                        1:20</div>

                </div>
                <div>
                    <div
                        className={`quant-c cursor ${focused === 1 ? "focused" : ""}`}
                        onClick={() => {
                            inputRef2.current?.focus(); // only focus, no cursor positioning
                            setFocused(1)

                        }}
                    >
                        <div className="quanc-h">
                            TP
                        </div>
                        <Input size="small"
                            variant="borderless"
                            type="number"
                            placeholder={0}
                            ref={inputRef2}

                        />
                    </div>
                    <div
                        className={`quant-c cursor mt-5 ${focused === 2 ? "focused" : ""}`}
                        onClick={() => {
                            inputRef3.current?.focus(); // only focus, no cursor positioning
                            setFocused(2)
                        }}
                    >
                        <div className="quanc-h">
                            SLO
                        </div>
                        <Input size="small"
                            variant="borderless"
                            type="number"
                            placeholder={0}
                            ref={inputRef3}

                        />
                    </div>
                </div>
                <Button className="buy-btn" onClick={handleAddPlotLine}>
                    BUY AT
                    <div className="set-at">
                        11.908
                    </div>
                </Button>

                <Button className="sell-btn">
                    SELL AT
                    <div className="set-at">
                        11.908
                    </div>
                </Button>


            </div>
        </>
    );
};

export default LiveHighChart;
